// The filters of a GitHub Issues or Asana source: a repository with optional labels and
// assignee, or a project gid with an optional section.
import { Input, Switch } from "rizzui";

import { useT } from "../../../i18n";
import { Hint } from "../../../ui/SideDrawer";
import type { Draft } from "../draft";

type Change = (patch: Partial<Draft>) => void;

export function GithubFields({ draft, onChange }: { draft: Draft; onChange: Change }) {
  const t = useT().tasks.create.github;
  const set = (patch: Partial<Draft["github"]>) => onChange({ github: { ...draft.github, ...patch } });
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <div className="sm:col-span-2">
        <Input label={t.repo} placeholder="acme/payments" value={draft.github.repo} onChange={(e) => set({ repo: e.target.value })} />
        <Hint>{t.repoHint}</Hint>
      </div>
      <div>
        <Input label={t.labels} placeholder="agent, bug" value={draft.github.labels} onChange={(e) => set({ labels: e.target.value })} />
        <Hint>{t.labelsHint}</Hint>
      </div>
      <div>
        <Input label={t.assignee} placeholder="octocat" value={draft.github.assignee} onChange={(e) => set({ assignee: e.target.value })} />
        <Hint>{t.assigneeHint}</Hint>
      </div>
      <div className="sm:col-span-2">
        <Switch label={t.includeClosed} checked={draft.github.includeClosed} onChange={(e) => set({ includeClosed: e.target.checked })} />
        <Hint>{t.includeClosedHint}</Hint>
      </div>
    </div>
  );
}

export function AsanaFields({ draft, onChange }: { draft: Draft; onChange: Change }) {
  const t = useT().tasks.create.asana;
  const set = (patch: Partial<Draft["asana"]>) => onChange({ asana: { ...draft.asana, ...patch } });
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <div>
        <Input label={t.project} inputMode="numeric" placeholder="1201234567890" value={draft.asana.project} onChange={(e) => set({ project: e.target.value })} />
        <Hint>{t.projectHint}</Hint>
      </div>
      <div>
        <Input label={t.section} inputMode="numeric" value={draft.asana.section} onChange={(e) => set({ section: e.target.value })} />
        <Hint>{t.sectionHint}</Hint>
      </div>
    </div>
  );
}
